import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import useWindowSize from 'hooks/use-windowSize';
import MiniContentCard from '@core/components/minicontentcard/MiniContentCard';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import classes from './RelatedJobCourses.module.scss';

const RelatedJobCourses = ({data}) => {
    const { mobileDevice, tabletDevice } = useWindowSize();
    return (
        <>
            {data?.length > 0 && (
                <div className={classes['courses']}>
                    <h5>Your Roadmap to This Job</h5>
                    <Swiper
                        slidesPerView={mobileDevice ? 0.9 : tabletDevice ? 1 : 1.3}
                        spaceBetween={30}
                        className="mySwiper">
                        {data?.map((card) => (
                            <SwiperSlide key={card.id + card.type}>
                                <div className='p-2'>
                                    <MiniContentCard content={card} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </>
    );
};

export default RelatedJobCourses;